import React, { Suspense, lazy, useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import './styles/globals.css';

// Lazy load all pages for code splitting
const IndexPage = lazy(() => import('./pages/IndexPage').then(m => ({ default: m.IndexPage })));
const DonatePage = lazy(() => import('./pages/DonatePage').then(m => ({ default: m.DonatePage })));
const ContactPage = lazy(() => import('./pages/ContactPage').then(m => ({ default: m.ContactPage })));
const AboutPage = lazy(() => import('./pages/AboutPage').then(m => ({ default: m.AboutPage })));
const BlogPage = lazy(() => import('./pages/BlogPage').then(m => ({ default: m.BlogPage })));
const ProgramsPage = lazy(() => import('./pages/ProgramsPage').then(m => ({ default: m.ProgramsPage })));
const StrategiesPage = lazy(() => import('./pages/StrategiesPage').then(m => ({ default: m.StrategiesPage })));
const ObjectivesPage = lazy(() => import('./pages/ObjectivesPage').then(m => ({ default: m.ObjectivesPage })));
const TeamPage = lazy(() => import('./pages/TeamPage').then(m => ({ default: m.TeamPage })));
const HistoriePage = lazy(() => import('./pages/HistoriePage').then(m => ({ default: m.HistoriePage })));
const ValuesPage = lazy(() => import('./pages/ValuesPage').then(m => ({ default: m.ValuesPage })));
const ImpactPage = lazy(() => import('./pages/ImpactPage').then(m => ({ default: m.ImpactPage })));
const OurWorkPage = lazy(() => import('./pages/OurWorkPage').then(m => ({ default: m.OurWorkPage })));
const OurWorkProjectsPage = lazy(() => import('./pages/OurWorkProjectsPage').then(m => ({ default: m.OurWorkProjectsPage })));
const ProjectDetailPage = lazy(() => import('./pages/ProjectDetailPage').then(m => ({ default: m.ProjectDetailPage })));
const BlogDetailPage = lazy(() => import('./pages/BlogDetailPage').then(m => ({ default: m.BlogDetailPage })));
const AdminBlogPage = lazy(() => import('./pages/AdminBlogPage').then(m => ({ default: m.AdminBlogPage })));
const VolunteerPage = lazy(() => import('./pages/VolunteerPage').then(m => ({ default: m.VolunteerPage })));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
  </div>
);

const App = () => {
  const [loading, setLoading] = useState(true);
  const handleFinish = useCallback(() => setLoading(false), []);

  return (
    <>
      {loading && <LoadingScreen onFinish={handleFinish} />}
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/" element={<IndexPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/about/nos-valeurs" element={<ValuesPage />} />
        <Route path="/our-work" element={<OurWorkPage />} />
        <Route path="/our-work/impact" element={<ImpactPage />} />
        <Route path="/our-work/programs" element={<ProgramsPage />} />
        <Route path="/our-work/projets" element={<OurWorkProjectsPage />} />
        <Route path="/our-work/projets/:projectId" element={<ProjectDetailPage />} />
        <Route path="/about/strategies" element={<StrategiesPage />} />
        <Route path="/about/objectives" element={<ObjectivesPage />} />
        <Route path="/about/team" element={<TeamPage />} />
        <Route path="/about/histoire" element={<HistoriePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:articleId" element={<BlogDetailPage />} />
        <Route path="/admin/blog" element={<AdminBlogPage />} />
        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/benevole" element={<VolunteerPage />} />
        </Routes>
      </Suspense>
    </Router>
    </>
  );
};

export default App;
